export interface SelectOption<T extends string> {
  value: T | null;
  label: string;
}

export const COUPON = {
  /** 어드민 발행 */
  ADMIN_PUBLISH: 'ADMIN_PUBLISH',
  /** 코드형 */
  CODE: 'CODE',
  /** 다운로드형 */
  DOWNLOAD: 'DOWNLOAD',
  /** CRM 다운로드형 */
  CRM_DOWNLOAD: 'CRM_DOWNLOAD',
  /** 자동발급형 */
  AUTO_PUBLISH: 'AUTO_PUBLISH',
  /** 난수쿠폰형 */
  RANDOM_CODE: 'RANDOM_CODE',
  /** 첫구매형 */
  FIRST_ORDER: 'FIRST_ORDER',
  /** 비공개형 */
  HIDDEN: 'HIDDEN',
} as const;

export const COUPON_TYPE_OPTIONS: SelectOption<CouponType>[] = [
  { value: COUPON.ADMIN_PUBLISH, label: '어드민 발행' },
  { value: COUPON.CODE, label: '코드형' },
  { value: COUPON.DOWNLOAD, label: '다운로드형' },
  { value: COUPON.FIRST_ORDER, label: '첫구매형' },
  { value: COUPON.AUTO_PUBLISH, label: '자동발급형' },
  { value: COUPON.RANDOM_CODE, label: '난수쿠폰형' },
  { value: COUPON.HIDDEN, label: '다운로드 비공개형' },
];

export type CouponType = typeof COUPON[keyof typeof COUPON];

export interface CouponMold {
  /** 쿠폰틀 ID */
  id: string;
  /** 쿠폰명 ID */
  title: string;
  /** 쿠폰 발급유형 */
  type: CouponType;
  /** 쿠폰 발급시작일 */
  publishStartAt?: string;
  /** 쿠폰 발급종료일 */
  publishEndAt?: string;
  /** 자동발급 여부 */
  autoPublish?: boolean;
}

export const CUSTOMER_TYPE = {
  ALL: 'ALL',
} as const;

export const COUPON_TYPE = {
  PRODUCT: 'PRODUCT',
} as const;

export const DISCOUNT_TYPE = {
  FIXED_AMOUNT: 'FIXED_AMOUNT',
  FIXED_RATE: 'FIXED_RATE',
} as const;

export const PUBLISH_TYPE = {
  DOWNLOAD: 'DOWNLOAD',
  CRM_DOWNLOAD: 'CRM_DOWNLOAD',
} as const;

export const EXPIRATION_TYPE = {
  FIXED_DATE: 'FIXED_DATE',
  DAYS_AFTER_PUBLISH: 'DAYS_AFTER_PUBLISH',
} as const;

export const PUBLISH_STATE = {
  BEFORE_PUBLISH: 'BEFORE_PUBLISH',
  PUBLISHABLE: 'PUBLISHABLE',
  PUBLISH_EXPIRED: 'PUBLISH_EXPIRED',
  TERMINATED_BY_ADMIN: 'TERMINATED_BY_ADMIN',
  TERMINATED_BY_BUDGET: 'TERMINATED_BY_BUDGET',
  TERMINATED_BY_COUNT: 'TERMINATED_BY_COUNT',
} as const;

export const SETTLEMENT_METHOD_TYPE = {
  SETTLEMENT_DEDUCTION: 'SETTLEMENT_DEDUCTION',
  CREDIT: 'CREDIT',
} as const;

export type CustomerType = typeof CUSTOMER_TYPE[keyof typeof CUSTOMER_TYPE];
export type ProductCouponType = typeof COUPON_TYPE[keyof typeof COUPON_TYPE];
export type PublishType = typeof PUBLISH_TYPE[keyof typeof PUBLISH_TYPE];
export type ExpirationType = typeof EXPIRATION_TYPE[keyof typeof EXPIRATION_TYPE];
export type DiscountType = typeof DISCOUNT_TYPE[keyof typeof DISCOUNT_TYPE];
export type PublishState = typeof PUBLISH_STATE[keyof typeof PUBLISH_STATE];
export type SettlementMethodType = typeof SETTLEMENT_METHOD_TYPE[keyof typeof SETTLEMENT_METHOD_TYPE];

export interface ProductCouponMold {
  couponMoldId: number;
  couponName: string;
  publishState: PublishState;
  couponType: CouponType;
  expirationType: ExpirationType;
  fixedExpiredAt?: string;
  expiredInDays?: number;
  publishStartDate: string;
  publishEndDate: string;
  ownerId: string;
  ownerNickname: string;
  ownerTeam: string;
  ownerTeamName: string;
  totalBudget: number;
  usedBudget: number;
  publishedCnt: number;
  usedCouponCnt: number;
  createdAt: string;
  createdBy?: string;
  limitBudgetRate?: number;
  limitPublishCnt?: number;
  publishStateAt: string;
  discountType: DiscountType;
  discountAmount?: number;
  discountRate?: number;
  maxDiscountAmount?: number;
  publishType: PublishType;
  customerType: CustomerType;
  settlementMethodType: SettlementMethodType;
  appOnly: boolean;
  autoPublish?: boolean;
  publishCntPerUser: number;
  minBaseAmount: number;
  chargeRate: number;
  description?: string;
  serviceId: string;
  modifiedBy?: string;
  modifiedAt?: string;
}
